module.exports = __webpack_public_path__ + "img/sap.faf03d95.svg";